export default __webpack_public_path__ + "static/media/startInSeconds.0cdc0c3c.png";